import { create } from 'zustand'

export const useAppStore = create((set) => ({
  isLegacy: false,
  setIsLegacy: (value) => set({ isLegacy: value })
}))